import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Section, SectionHeading, Reveal } from './ui/Section';

const SCREENS = [
  {
    id: 'ai',
    tab: 'AI取引入力',
    title: 'AI取引入力アシスタント',
    body: '日本語で取引内容を伝えるだけで、AIが勘定科目と税区分を判定し、仕訳の形に整えます。専門知識がなくても入力が進みます。',
    src: '/images/screen1.png',
  },
  {
    id: 'tax',
    tab: '消費税集計',
    title: '消費税区分集計表',
    body: '税区分ごとの集計を自動で作成。インボイス制度に沿った区分管理も、入力時点で仕分けられているため確認がすぐ終わります。',
    src: '/images/screen2.png',
  },
  {
    id: 'account',
    tab: '勘定科目管理',
    title: '勘定科目管理',
    body: '自社の実態に合わせて科目を柔軟に設定。階層構造で管理できるため、集計軸を変えても数字の整合性が保たれます。',
    src: '/images/screen3.png',
  },
];

const Screens: React.FC = () => {
  const [active, setActive] = useState(0);
  const current = SCREENS[active];

  return (
    <Section id="screens" tone="muted">
      <SectionHeading
        eyebrow="Screens"
        title="実際の画面"
        lead="実際にご利用いただく画面です。30日間の無料体験で、そのままお試しいただけます。"
      />

      {/* タブ */}
      <Reveal delay={0.1}>
        <div className="mt-12 flex flex-wrap justify-center gap-2">
          {SCREENS.map((s, i) => (
            <button
              key={s.id}
              onClick={() => setActive(i)}
              aria-pressed={i === active}
              className={`rounded-pill px-5 py-2.5 text-small font-bold transition-all ${
                i === active
                  ? 'bg-ink-900 text-white shadow-card'
                  : 'border border-line-strong bg-white text-body-soft hover:border-ink-300 hover:text-ink-800'
              }`}
            >
              {s.tab}
            </button>
          ))}
        </div>
      </Reveal>

      <Reveal delay={0.16}>
        <div className="mt-10 grid gap-8 lg:grid-cols-[1.6fr_1fr] lg:items-center">
          {/* スクリーンショット（ウィンドウ枠つき） */}
          <div className="overflow-hidden rounded-card border border-line bg-white shadow-card">
            <div className="flex items-center gap-2 border-b border-line bg-surface-muted px-4 py-3">
              <span className="h-2.5 w-2.5 rounded-full bg-line-strong" />
              <span className="h-2.5 w-2.5 rounded-full bg-line-strong" />
              <span className="h-2.5 w-2.5 rounded-full bg-line-strong" />
              <span className="ml-3 text-xs font-medium text-body-faint">
                サクミエ会計 — {current.title}
              </span>
            </div>
            <div className="relative bg-white">
              <AnimatePresence mode="wait">
                <motion.img
                  key={current.id}
                  src={current.src}
                  alt={current.title}
                  loading="lazy"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                  transition={{ duration: 0.25 }}
                  className="block w-full"
                />
              </AnimatePresence>
            </div>
          </div>

          {/* 説明 */}
          <div>
            <AnimatePresence mode="wait">
              <motion.div
                key={current.id}
                initial={{ opacity: 0, y: 12 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -8 }}
                transition={{ duration: 0.3 }}
              >
                <h3 className="text-h3 text-ink-900">{current.title}</h3>
                <p className="mt-4 text-body leading-relaxed text-body-soft">{current.body}</p>
              </motion.div>
            </AnimatePresence>

            <div className="mt-8">
              <a href="/monitor.html" className="btn btn-md btn-primary">
                この画面を実際に試す
              </a>
            </div>
          </div>
        </div>
      </Reveal>
    </Section>
  );
};

export default Screens;
